import { createStaticVNode, defineComponent, openBlock, createElementBlock } from 'vue';

const _hoisted_1 = {
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g id="p1-\u898F\u7BC4\u8207\u5207\u5716" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="p1-header/\u641C\u5C0B\u4EA4\u4E92" transform="translate(-878.000000, -1293.000000)"><g id="web/header/1920-1280\u5167\u5BB9\u5BEC\u5EA6\u5907\u4EFD" transform="translate(0.000000, 1269.000000)"><g id="\u83DC\u55AE" transform="translate(450.000000, 0.000000)"><g id="\u8CFC\u7269" transform="translate(0.000000, 20.000000)"><g transform="translate(389.000000, 0.000000)"><g id="icon/list/arrow/grey" transform="translate(39.000000, 4.000000)"><g id="icon_header_arrow" transform="translate(0.000000, 0.000000)"><rect id="bg" transform="translate(8.000000, 8.000000) rotate(-360.000000) translate(-8.000000, -8.000000) " x="1.77635684e-15" y="1.77635684e-15" width="16" height="16"></rect><path id="\u8DEF\u5F84" d="M9.9618117,3.85558722 L5.26696932,7.2291526 L5.17170268,7.30523107 C4.68926803,7.7373052 4.60884702,8.4519564 4.98174223,8.97089824 C5.05998026,9.07977867 5.1552522,9.17534041 5.26389451,9.25390878 L9.95980252,12.649914 L10.0544621,12.7083368 C10.4265309,12.8958302 10.8623851,12.7934568 11.0984771,12.4669948 L11.1568999,12.3723352 L11.2017524,12.2705866 L11.2318417,12.1653371 C11.3007351,11.8431834 11.1782522,11.5182965 10.9155579,11.3283202 L6.59358405,8.20146993 L10.9135078,5.18010713 L10.998895,5.10873928 C11.2943827,4.8150086 11.335025,4.36914161 11.0999255,4.04196397 C10.8371106,3.67621601 10.3275597,3.5927723 9.9618117,3.85558722 Z" fill="#1E1E1E" fill-rule="nonzero" transform="translate(7.999953, 8.251967) rotate(-90.000000) translate(-7.999953, -8.251967) "></path></g></g></g></g></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
const __default__ = defineComponent({
  name: "TvbArrowIcon"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  setup(__props) {
    ;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=Arrow.vue2.mjs.map
